import $ from 'jquery';
import jqueryWordAndCharCounter from 'jquery-word-and-char-counter';
import _ from 'underscore';
import Backbone from 'backbone';

var QuestionView = Backbone.View.extend({

    events: {
        'click input[type="radio"]:checked': 'radioClicked',
        'keyup textarea': 'textWritten'
    },

    initialize: function() {
        const pollId = this.model.get('id');

        this.$('textarea').counter({
            count: 'down',
            goal: 500,
            text: false
        });
        this.$(`#poll-textarea-${pollId}_count`).css({
            'position': 'absolute',
            'right': '75px',
            'bottom': '5px'
        });
    },

    radioClicked: function(e) {
        this.model.set('answer', $(e.target).val());
    },

    textWritten: function(e) {
        var txt = $(e.target).val();
        if (!txt || _.isEmpty(txt)){
            this.model.unset('answer');
            $(e.target).css('color', '#93969F');
            return;
        }
        $(e.target).css('color', '#000000');
        this.model.set('answer', $(e.target).val());
    }

});

export default QuestionView;


